import type { Grid } from '../inventory/Grid';

export const RAW = 'raw';
export const COOKED = 'cooked';
export const COOK_HUNGER = 35;
export const RAW_DROP = 1;

export type CookVitals = { addHunger(delta: number): void };

/** Lit fire / workbench / rack: raw → cooked. Does not eat. */
export function cookRaw(inv: Grid, _vitals: CookVitals | null, fireLit: boolean): boolean {
  if (!fireLit || inv.countOf(RAW) < 1) {
    return false;
  }
  if (!inv.remove(RAW, 1)) {
    return false;
  }
  if (inv.add(COOKED, 1) !== 0) {
    inv.add(RAW, 1);
    return false;
  }
  return true;
}

/** Eat one cooked. +35 hunger. */
export function eatCooked(inv: Grid, vitals: CookVitals): boolean {
  if (inv.countOf(COOKED) < 1) {
    return false;
  }
  if (!inv.remove(COOKED, 1)) {
    return false;
  }
  vitals.addHunger(COOK_HUNGER);
  return true;
}

export function grantRaw(inv: Grid, n = RAW_DROP): number {
  return inv.add(RAW, n);
}

export function meatYield(kind: string): number {
  if (kind === 'rex' || kind === 'spino' || kind === 'trike' || kind === 'stego' || kind === 'anky') {
    return 4;
  }
  if (kind === 'para' || kind === 'baryonyx' || kind === 'carno' || kind === 'diloph') {
    return 2;
  }
  return 1;
}
